import { ToggleLeft, ToggleRight } from 'lucide-react';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'toggle',
  renderInput: ({ value, onChange }) => {
    const isOn = Boolean(value);
    return (
      <button
        type="button"
        onClick={() => onChange(!isOn)}
        className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2 ${isOn ? 'bg-accent-600' : 'bg-border-primary'}`}
        role="switch"
        aria-checked={isOn}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${isOn ? 'translate-x-6' : 'translate-x-1'}`}
        />
      </button>
    );
  },
  renderCell: (_field, value) => {
    const isOn = Boolean(value);
    return (
      <div className="flex items-center gap-1.5">
        {isOn ? (
          <ToggleRight className="h-4 w-4 text-accent-600" />
        ) : (
          <ToggleLeft className="h-4 w-4 text-text-muted" />
        )}
        <span className={`text-xs font-medium ${isOn ? 'text-accent-600' : 'text-text-muted'}`}>
          {isOn ? 'Tak' : 'Nie'}
        </span>
      </div>
    );
  },
  validate: () => null,
  defaultValue: false,
});
